import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../../common/constants";
import { deleteIotAgentBlobUrl } from "../../../config";
import api from "../../../api";

const DELETE_IOT_AGENT: string = "deleteIotAgent";

interface IDeleteIotAgentState {
  status: string;
  msg: string | null;
  error: string | null;
}

const initialState: IDeleteIotAgentState = {
  status: Status.IDLE,
  msg: null,
  error: null,
};

export const deleteIotAgent: any = createAsyncThunk(
  DELETE_IOT_AGENT,
  async ({ name, version }: { name: string; version: string }) => {
    try {
      const url = `${deleteIotAgentBlobUrl}?name=${name}&version=${version}`;
      const response = await api.delete(url);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "Delete IoT Agent failed";
    }
  }
);

const deleteIotAgentSlice = createSlice({
  name: "deleteIotAgent",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteIotAgent.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
        state.error = null;
      })
      .addCase(deleteIotAgent.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.msg = action.payload?.message || "IoT Agent deleted successfully";
      })
      .addCase(deleteIotAgent.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message;
        state.msg = action.error.message || "Failed to delete IoT Agent";
      });
  },
});

type Selector = {
  deleteIotAgentApi: ReturnType<typeof deleteIotAgentSlice.reducer>;
};

export const selector = (store: Selector) => store["deleteIotAgentApi"];

export default deleteIotAgentSlice.reducer;
